import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const uptycs = defineConnector({
  identifier: "uptycs",
  name: "Uptycs",
  tagLine: "Cloud-native security analytics",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.uptycs\\.io/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/public/api/customers/${app.config.customerId}/apiKeys`,
        jsonBody: {
          key: app.secret.apiKey,
          secret: app.secret.apiSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["accessToken"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Generate API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Uptycs, go to **Configurations → Users**, open your user profile, and click **Create** under User API key. Download the JSON key file.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
        {
          kind: "hostname",
          label: "Domain",
          placeholder: "your-tenant.uptycs.io",
          required: true,
          target: { kind: "configuration", field: "domain" },
        },
        {
          kind: "input",
          label: "Customer ID",
          required: true,
          target: { kind: "configuration", field: "customerId" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain, customerId }) =>
      `https://${domain}/public/api/customers/${customerId}/users`,
  },
  publicEnvVars: ({ domain, customerId }) => ({
    UPTYCS_URL: domain ? `https://${domain}` : "",
    UPTYCS_CUSTOMER_ID: customerId || "",
  }),
});
